module.exports = __webpack_public_path__ + "static/img/yuangong.f62e3852.png";